export async function downloadFile(
  url: string,
  filename: string,
): Promise<void> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(
      `Download failed: ${response.status} ${response.statusText}`,
    );
  }

  const blob = await response.blob();
  const objectUrl = window.URL.createObjectURL(blob);

  const link = window.document.createElement('a');
  link.href = objectUrl;
  link.download = filename;
  window.document.body.appendChild(link);
  link.click();

  window.URL.revokeObjectURL(objectUrl);
  window.document.body.removeChild(link);
}
